// extracted by mini-css-extract-plugin
export default {"page":"lL","freeShippingContainer":"mL","customizeContainer":"nL","customizeHeader":"oL","fadein":"pL","customizeText":"qL","hidden":"rL","productcard":"sL","accordeonscontainer":"tL","freeShipping":"uL","mainpart":"vL"};
    if(module.hot) {
      // 1738836197133
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  